import { VxeForm } from 'vxe-pc-ui';
export default {
  name: 'XForm',
  components: {
    VxeForm
  }
};